import styled from 'styled-components/macro';

export const StyledTr = styled.tr<{ isMulti: boolean }>`
  border-bottom: 1px solid #eef0f4;
  display: table;
  table-layout: fixed;
  width: 100%;

  & > td {
    vertical-align: ${(props) => (props.isMulti ? 'top' : 'middle')};
    color: #1f2a37;
    font-size: 14px;
    font-weight: 400;
    padding: 14px 0;

    &:nth-child(1) {
      @media (max-width: 1350px) {
        width: 111px;
      }
    }

    &:nth-child(3) {
      vertical-align: middle;
      width: 50px;
    }

    & .list-item-text:not(:last-child) {
      margin-bottom: 8px;
    }
  }
`;

export const MultiField = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;

  & > .meter-input-wrapper:not(:last-child) {
    margin-bottom: 16px;
  }

  & > span:not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const CheckboxAbsWrapper = styled.div`
  position: absolute;
  left: -30px;
`;

export const CheckDate = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const ListItemText = styled.div.attrs({
  className: 'list-item-text',
})<{ isElapsed?: boolean }>`
  color: ${(props) => (props.isElapsed ? '#E53E3E' : '#1f2939')};
`;

export const ListItemSubText = styled.span.attrs({
  className: 'list-item-text',
})`
  color: #495466;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;
`;

export const AutomaticLogo = styled.i.attrs({
  className: 'fas fa-wifi',
})`
  width: 16px;
  height: 16px;
  color: #868f9e;
  font-size: 12px;
`;
